export default function registerIdHelper() {
  return new Promise(function (resolve) {
    window.ramblerIdHelper = window.ramblerIdHelper || [];
    window.ramblerIdHelper.push(function () {
      resolve(window.ramblerIdHelper);
    });
  });
}